<template>
  <div>

    <template v-if="insight && insight.type">
      <template v-if="reportReady">
        	<bar-chart-2 v-if="insight.type === 'bar'" :data="reportData" :title="insight.title"></bar-chart-2>
        	<sankey v-if="insight.type === 'sankey'" :data="reportData" :title="insight.title"></sankey>
        	<tree-structure v-if="insight.type === 'tree'" :title="insight.title"></tree-structure>
          <fastest-growing-careers-list v-if="insight.type === 'fastest-list'" :data="reportData"  :title="insight.title"></fastest-growing-careers-list>
          <largest-employment-careers-list v-if="insight.type === 'largest-list'" :data="reportData" :title="insight.title"></largest-employment-careers-list>
      </template>
    </template>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BarChart2 from './BarChart2'
import Sankey from './Sankey'
import TreeStructure from './TreeStructure'
import FastestGrowingCareersList from './FastestGrowingCareersList'
import LargestEmploymentCareersList from './LargestEmploymentCareersList'

export default {
  name: 'exploreInsight',
  props: ['insight'],
  components: {
    BarChart2,
    Sankey,
    TreeStructure,
    FastestGrowingCareersList,
    LargestEmploymentCareersList
  },
  data: () => {
    return {
      reportData: {},
      reportReady: false
    }
  },

  mounted () {
    this.loadInsight()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'setCurrentFacet',
      'loadAlumniReport',
      'loadFastestGrowingCareers',
      'loadCareersWithLargestEmployment'
    ]),
    async loadInsight () {
      if (this.insight) {
        if (this.insight.type === 'largest-list') {
          let res = await this.loadCareersWithLargestEmployment()
          this.reportData = res.content
          this.reportReady = true
        } else if (this.insight.type === 'fastest-list') {
          let res = await this.loadFastestGrowingCareers()
          this.reportData = res.content
          this.reportReady = true
        } else {
          var query = 'reportName=' + this.insight.reportName + '&count=100'
          if (this.insight.targetName && this.insight.targetName.length > 0) {
            query = query + '&targetName=' + this.insight.targetName
          }

          if (this.insight.title === 'Program to Career') {
            console.log('Program name matches')
            let response = await this.loadAlumniReport(this.insight.title)
            let sankeyObj = JSON.parse(response[0].description)
            console.log('Res: ', sankeyObj)
            this.reportData = sankeyObj
            this.reportReady = true
          } else if (this.insight.title === 'Popular Employers') {
            let response = await this.loadAlumniReport(this.insight.title)
            let reportObj = JSON.parse(response[0].description)
            this.reportData = reportObj
            this.reportReady = true
          } else if (this.insight.title === 'Popular Post Grad Job Titles') {
            let response = await this.loadAlumniReport(this.insight.title)
            let reportObj = JSON.parse(response[0].description)
            this.reportData = reportObj
            this.reportReady = true
          }
        }
      }
    }
  },

  computed: {
    ...mapState({
      'enabledFeatures': state => state.institution.enabledFeatures,
      'currentFacet': state => state.explore.currentFacet
    })
  },

  watch: {
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreInsight.vue